import React from 'react'
import classNames from 'classnames'
import './index.less'

enum TypeEnum {
  S='S',
  M='M',
  L='L'
}

export interface SwitchProps{
  type?: TypeEnum,
  disabled?: boolean,
  active?:boolean,
  className?: string;
  style?: React.CSSProperties;
  onChange?: (val:boolean)=>void;
}

export default ({ className, style, onChange, disabled, active, type = TypeEnum.M }:SwitchProps) => {
  return <div
    className={classNames('mn-switch', { disabled, active, [type]: true }, className)}
    style={style}
    onClick={() => {
      if (disabled) { return }
      onChange?.(!active)
    }}
  >
    <div className="circle" />
  </div>
}
